import { createFileRoute, Navigate } from '@tanstack/react-router'

/**
 * Route configuration for the application root path.
 * Redirects to document-upload if authenticated, otherwise to sign-in.
 */
export const Route = createFileRoute('/')({
  component: Index,
})

/**
 * Index page component.
 * Automatically redirects users to the document upload page if authenticated,
 * or to the sign-in page if not authenticated.
 *
 * @returns Navigation redirect to /document-upload or /signin
 */
function Index() {
  const { auth } = Route.useRouteContext()

  if (!auth.isAuthenticated) {
    return <Navigate to="/signin" search={{ redirect: '/document-upload' }} />
  }

  return <Navigate to="/document-upload" />
}
